<template>
  <div class="component">
    <transition enter-active-class="fade-in-up">
      <div class="container px-xs-sm-2" v-if="inview">
        <div class="row">
          <div class="col-md-6">
            <div v-if="this.$root.browser !== 'is-ie'" class="animation">
              <animation v-bind:animation="animation"></animation>
            </div>
            <figure v-else>
              <img
                class="img-fluid"
                src="@/assets/images/illustration-healthcare-professionals.svg"
              />
            </figure>
          </div>
          <div class="col-md-6">
            <div class="headings pt-6 pt-md-0">
              <eyebrow-icon
                v-if="eyebrowicon"
                v-bind:eyebrowicon="eyebrowicon"
              ></eyebrow-icon>
              <div class="title">
                <h5 class="heading-xs" v-html="name"></h5>
              </div>
              <h1 class="heading-lg" v-html="headline"></h1>

              <div class="content">
                <p v-html="content"></p>
              </div>
              <a
                v-bind:href="cta.href"
                v-bind:target="cta.target"
                class="btn"
                v-bind:class="{
                  'cta-plain text-red icon right-arrow': cta.style === 'text',
                  'cta-pill filled-red icon right-arrow ctaButton': cta.style === 'pill',
                }"
                >{{ cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import inview from "../../mixins/inview";

export default {
  name: "for-professionals",
  props: ["name", "headline", "eyebrowicon", "animation", "content", "cta"],
  mixins: [inview],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.title {
  @extend %body-normal-bold;
}

h1 {
  margin-bottom: 1.75rem;
}

h5 {
  position: relative;
  margin-bottom: 0.75rem;

  &:before {
    content: "";
    position: absolute;
    top: -1rem;
    left: 0;
    width: 1.25rem;
    height: 3px;
    background-color: $cc-resmed-black;
  }
}

.animation {
  transform: scale(1.325);

  @media (min-width: 768px) {
    transform: scale(1.425);
  }

  @media (min-width: 992px) {
    transform: scale(1.125) translateX(-1.5rem) translateY(-2.75rem);
  }

  @media (min-width: 1200px) {
    transform: scale(1.225) translateX(-3.5rem) translateY(-2.75rem);
  }
}

.headings {
  @media (min-width: 1200px) {
    transform: translateY(4.5rem);
  }
}

.content {
  margin-bottom: 1.5rem;

  p {
    @media (min-width: 992px) {
      padding-right: 4rem;
    }

    @media (min-width: 1200px) {
      padding-right: 6.25rem;
    }
  }
}
</style>

<style lang="scss">
.for-professionals {
  overflow: hidden;
  h1 {
    span {
      display: block;
    }
  }
}
</style>